import { createStore } from 'jotai';
import {
  errorAtom,
  planDetailAtom,
  planDetailRecommendedAtom,
  selectedSubjectIdAtom,
  subscriptionsAtom,
  successAtom,
  userDetailAtom,
} from '@components/subscription/store/SubscriptionAtoms';

const SubscriptionStore = createStore();

// default value of the atom
export function resetDefaultSubscriptionState() {
  SubscriptionStore.set(subscriptionsAtom, []);
  SubscriptionStore.set(selectedSubjectIdAtom, null);
  SubscriptionStore.set(planDetailAtom, null);
  SubscriptionStore.set(planDetailRecommendedAtom, null);
  SubscriptionStore.set(userDetailAtom, null);
  SubscriptionStore.set(errorAtom, '');
  SubscriptionStore.set(successAtom, '');
}

resetDefaultSubscriptionState();
export default SubscriptionStore;
